<template>
  <div class="form-field select-search">
    <label for="">{{ title }}</label>
    <div
      class="input"
      @click="toggleSearch()"
    >
      <span v-if="selected && selected.title">{{ selected.title }}</span>
      <span v-else>Select a location</span>
    </div>

    <div
      v-if="isOpen"
      @click="isOpen = false"
      class="background"
    ></div>

    <div class="results" v-if="isOpen">
      <div class="flex form-field">
        <input
          type="text"
          v-model="text"
          @keyup="onFilterLocations()"
        >
        <button>
          <span class="material-icons-outlined">search</span>
        </button>
      </div>
      <div class="wrap">
        <ul>
          <li v-for="location of sortedLocations" :key="location.id">
            <a @click="selectLocation(location)">{{ location.title }}</a>
          </li>
        </ul>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  props: {
    locations: Array,
    init_id: Number | String,
    title: String
  },

  data: () => ({
    selected: {},
    sortedLocations: [],
    isOpen: false,
    text: ''
  }),

  mounted () {
    this.sortedLocations = this.locations
    if (this.init_id) {
      // pre-select location
      this.selected = this.sortedLocations.find(obj => obj.id == this.init_id)

    }
  },

  methods: {
    selectLocation (obj) {
      this.selected = obj
      console.log('in', obj)
      this.$emit('selectedLocation', this.selected.id)
      this.isOpen = false
    },

    onFilterLocations () {
      if (this.text) {
        var arrayFiltered = this.locations.filter( (obj) => {
            return obj.title.toLowerCase().indexOf(this.text.toLowerCase()) != -1
        });
        this.sortedLocations = arrayFiltered;
      } else {
        this.sortedLocations = this.locations
      }
    },

    toggleSearch () {
      this.isOpen = !this.isOpen
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.form-field.select-search {
  position: relative;

  .background {
    position: fixed;
    top: 0;
    left: 0;

    width: 100%;
    height: 100%;
  }

  .input {
    overflow: hidden;
  }

  .results {
    position: absolute;
    top: calc(100% + 10px);
    left: 0;
    z-index: 9999;

    min-width: 355px;
    margin: 0;
    padding: 0;

    background: white;
    border: 1px solid #E4E7ED;
    border-radius: 4px;
    box-shadow: 0 2px 12px 0 rgba(0,0,0,0.06);

    .form-field {
      margin: 0;
      padding: 6px;

      font-size: 15px;
      font-weight: 400;
      letter-spacing: 0.1px;

      input {
        display: inline-block;
        height: 30px;
        width: 100%;
        padding: 0 10px;

        border: 1px solid #000000;
        border-radius: 2px;
        background-color: #FFFFFF;
      }

      button {
        position: absolute;
        top: 8px;
        right: 10px;
        display: inline-block;
        width: 30px;
      }
    }

    .wrap {
      max-height: 310px;
      padding: 0 15px 0 0;

      overflow: scroll;

      ul {
        margin: 0;
        padding: 0;

        li {
          margin: 0;
          padding: 0 10px;

          font-size: 12.5px;
          line-height: 26px;
          color: black;

          a {
            display: inline-block;
            width: 100%;
            color: black;
          }
        }

        li:hover {
          background-color: red;
          a { color: white; }
        }
      }
    }
  }
}
</style>